import * as React from "react";
import { MapPin, Phone, Clock } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
export default function LocateOurStudio() {
  return <section data-section-id="223293" id="find-our-office" className="relative w-full h-[600px] md:h-[700px] bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673581/img/skillup_hq_map_dark.png')] bg-cover bg-center grayscale opacity-40" />

      {}
      <div className="absolute top-1/2 left-1/2 md:left-[60%] -translate-x-1/2 -translate-y-1/2 flex flex-col items-center justify-center z-0 pointer-events-none">
        <div className="relative animate-bounce" style={{
        animationDuration: '3s'
      }}>
          <MapPin className="w-14 h-14 text-chart-2 drop-shadow-2xl" strokeWidth={1.5} fill="currentColor" />
          <div className="absolute top-[35%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-4 h-4 bg-background rounded-lg shadow-inner" />
        </div>
        <div className="w-8 h-2 bg-black/40 rounded-lg mt-1 blur-[3px]" />
      </div>

      {}
      <div className="container mx-auto h-full relative pointer-events-none">
        <div className="absolute left-4 right-4 md:right-auto md:left-8 lg:left-12 top-1/2 -translate-y-1/2 md:w-full md:max-w-[400px] pointer-events-auto z-10">
          <Card className="bg-background/40 backdrop-blur-xl border-white/10 shadow-3xl rounded-lg">
            <CardHeader className="pb-4 border-b border-white/10">
              <CardTitle className="font-default text-2xl tracking-tighter text-primary">
                SKILLUP Headquarters
              </CardTitle>
            </CardHeader>
            <CardContent className="pt-6 space-y-8">
              {}
              <div className="flex items-start gap-4">
                <div className="bg-secondary/10 p-2.5 rounded-lg shrink-0">
                  <MapPin className="w-5 h-5 text-secondary" />
                </div>
                <div>
                  <h4 className="font-default font-bold text-foreground mb-1">
                    Our Address
                  </h4>
                  <p className="text-muted-foreground text-sm leading-relaxed font-default">
                    Innovation Hub, Long Ships (PTY) Ltd
                    <br />
                    Cala, Eastern Cape 5414
                  </p>
                </div>
              </div>

              {}
              <div className="flex items-start gap-4">
                <div className="bg-secondary/10 p-2.5 rounded-lg shrink-0">
                  <Phone className="w-5 h-5 text-secondary" />
                </div>
                <div>
                  <h4 className="font-default font-bold text-foreground mb-1">
                    BPO & Training Inquiries
                  </h4>
                  <div className="space-y-1">
                    <p className="text-muted-foreground text-sm font-mono">
                      +27 (0) 63 565 0933
                    </p>
                    <p className="text-muted-foreground text-sm font-mono">
                      +27 (0) 63 565 0933
                    </p>
                  </div>
                </div>
              </div>

              {}
              <div className="flex items-start gap-4">
                <div className="bg-secondary/10 p-2.5 rounded-lg shrink-0">
                  <Clock className="w-5 h-5 text-secondary" />
                </div>
                <div>
                  <h4 className="font-default font-bold text-foreground mb-1">
                    Operational Hours
                  </h4>
                  <div className="space-y-1">
                    <p className="text-muted-foreground text-sm font-default">
                      Mon - Fri: 8:00 AM - 6:00 PM
                    </p>
                    <p className="text-muted-foreground text-sm font-default">
                      Sat: 9:00 AM - 1:00 PM
                    </p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}